var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5 32.0358L28.125 37.6608L37.5 24.5358M30 6.9458C24.3393 12.3214 16.8007 15.2697 8.99501 15.1608C8.0021 18.1857 7.49744 21.3496 7.50001 24.5333C7.50001 38.5133 17.06 50.2583 30 53.5908C42.94 50.2608 52.5 38.5158 52.5 24.5358C52.5 21.2608 51.975 18.1083 51.005 15.1583H50.625C42.635 15.1583 35.375 12.0383 30 6.9458Z",
    stroke: "#60A5FA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.74c617dcfd3991ea5891caf3a47ee8fb.svg";
export { ForwardRef as ReactComponent };